import { UploadOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, Input, message, Select, Upload } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SERVER_ADDRESS } from "../../../Config/Config";

const EditAudio = () => {
  const [form] = Form.useForm();
  const [audioSrc, setAudioSrc] = useState(null);
  const [fileList, setFileList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;

  useEffect(() => {
    form.setFieldsValue({
      audio_name: data?.audio_name,
      audio_type: data?.audio_type,
    });
    setAudioSrc(data?.audio_url);
    setFileList([
      {
        uid: "-1",
        name: data.audio_name,
        status: "done",
        url: data.audio_url,
      },
    ]);
  }, []);

  const breadcrumbItems = [
    {
      path: "/dashboard",
      title: "Home",
    },
    {
      path: "/view-audio",
      title: "Audio list",
    },
  ];

  const handleAudioChange = ({ fileList }) => {
    const latestFileList = fileList.slice(-1);
    const latestFile = latestFileList[0];

    if (!latestFile || !latestFile.originFileObj) return;

    const file = latestFile.originFileObj;

    if (file.type !== "audio/mpeg") {
      message.warning("Only MP3 files are allowed.");
      setFileList([]);
      setAudioSrc(null);
      form.setFieldsValue({ audio_file: null });
      return;
    }

    const fileURL = URL.createObjectURL(file);
    const audio = new Audio();
    audio.src = fileURL;

    audio.onloadedmetadata = () => {
      if (audio.duration > 30) {
        message.warning("Audio must be 1 minute or less.");
        setFileList([]);
        setAudioSrc(null);
        form.setFieldsValue({ audio_file: null });
      } else {
        setFileList(latestFileList);
        setAudioSrc(fileURL);
        form.setFieldsValue({ audio_file: latestFile });
      }
    };
  };

  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append("audio_name", values.audio_name);
    formData.append("audio_type", values.audio_type);
    if (values.audio_file?.originFileObj) {
      formData.append("audio_file", values.audio_file.originFileObj);
    }

    // Add ID from route state
    formData.append("id", data.id);

    try {
      const response = await axios.post(
        `${SERVER_ADDRESS}/api/update-audio`,
        formData
      );
      const result = response.data;
      if (result.result === 1) {
        message.success(result.message);
        navigate("/view-audio");
      } else {
        message.warning(result.message);
      }
    } catch (error) {
      console.log(error);
      message.error("Something went wrong");
    }
  };

  return (
    <div style={{ marginTop: "4rem" }}>
      <div
        className="mt-3 p-4"
        style={{ backgroundColor: "white", borderRadius: "1rem" }}
      >
        <div className="d-flex flex-row justify-content-between">
          <h3 className="py-4">Edit Audio</h3>
          <Breadcrumb>
            {breadcrumbItems.map((item, index) => (
              <Breadcrumb.Item key={index}>
                <Link to={item.path}>{item.title}</Link>
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
        <div style={{ width: "60%", marginInline: "auto" }}>
          <Form onFinish={handleSubmit} form={form} layout="vertical">
            <Form.Item
              name="audio_type"
              label="Audio Name"
              rules={[{ required: true, message: "Select audio type" }]}
            >
              <Select
                placeholder="Select audio Type"
                options={[
                  {
                    value: 1,
                    label: "For You",
                  },
                  {
                    value: 2,
                    label: "Trending",
                  },
                  {
                    value: 3,
                    label: "Recommednded",
                  },
                ]}
              />
            </Form.Item>

            <Form.Item
              name="audio_name"
              label="Audio Name"
              rules={[{ required: true, message: "Enter audio name" }]}
            >
              <Input size="large" placeholder="Enter audio name" />
            </Form.Item>

            <Form.Item
              name="audio_file"
              label="Upload Audio"
              valuePropName="file"
            >
              <Upload
                accept="audio/*"
                beforeUpload={() => false}
                fileList={fileList}
                onChange={handleAudioChange}
                maxCount={1}
                onRemove={() => {
                  setAudioSrc(null);
                  form.setFieldsValue({ audio_file: null });
                  setFileList([]);
                }}
              >
                <Button icon={<UploadOutlined />}>Upload One Audio</Button>
              </Upload>
            </Form.Item>

            {audioSrc && (
              <Form.Item label="Preview">
                <audio controls src={audioSrc} style={{ width: "100%" }} />
              </Form.Item>
            )}

            <Form.Item>
              <Button htmlType="submit" type="primary">
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default EditAudio;
